import { find, map } from 'lodash';
import { Box, VStack } from 'native-base';

import { Text } from '@pimm/base';
import { EventPriority, InstanceDetailsDto } from '@pimm/services/lib/store-equipment';
import { EventType } from '../types';
import { getEventPriorityColor } from '../_helper';
import { useEquipmentConfig } from '../context/equipment-config.context';
import { BatteryEventIcon } from '../icons/battery-event';
import { DoorEventIcon } from '../icons/door-event';
import { TemperatureEventIcon } from '../icons/temperature-event';
import { WifiOffIcon } from '../icons/wifi-off';

type EventBoxProps = {
  instance?: InstanceDetailsDto;
  eventType: EventType;
};

export const EventBox = ({ instance, eventType = 'Temperature' }: EventBoxProps) => {
  const eventTypes = useEquipmentConfig(ctx => ctx.eventTypes);
  let alert, fill;

  if (instance) {
    const profiles = map(instance.EnabledEventTypes, num => find(eventTypes, event => event.EventType === num));
    const eventPriority = instance?.EventPriority ?? EventPriority.None;
    fill = getEventPriorityColor(eventPriority, eventType === 'Temperature');
    alert = profiles[0]?.Priorities
      ? find(profiles[0]?.Priorities, ['Priority', parseInt(instance?.EventPriority?.match(/\d+/)?.[0] || '', 10)])
      : null;
  }

  if (!fill) return null;
  const color = 'white';
  const opacity = 1;

  return (
    <VStack space={0.5} rounded="md" h={8} w={8} pt={0.5} alignItems="center" justifyContent="center" bgColor={color}>
      <Box rounded="full" boxSize={5} alignItems="center" justifyContent="center" bgColor={fill}>
        {eventType === 'Battery' && <BatteryEventIcon size="md" color={color} opacity={opacity} />}
        {eventType === 'Door' && <DoorEventIcon size="xs" color={color} opacity={opacity} />}
        {eventType === 'Signal' && <WifiOffIcon size="xs" color={color} opacity={opacity} />}
        {eventType === 'Temperature' && <TemperatureEventIcon size="md" color={color} opacity={opacity} />}
      </Box>
      {!!alert?.ShortString && (
        <Text size="xs" color="black" lineHeight="xs" fontWeight={700}>
          {alert?.ShortString}
        </Text>
      )}
    </VStack>
  );
};
